import { useMemo } from 'react'

export default (getValues: any, watch: any) => {
  watch([
    'carPrice',
    'trackingMonthlyRate',
    'servicePrice',
    'licencePrice',
    'compulsoryInsurancePrice',
    'comprehensiveInsurancePrice',
    'comprehensiveInsuranceYoungPrice',
  ])

  const [
    carPrice,
    trackingMonthlyRate,
    servicePrice,
    licencePrice,
    compulsoryInsurancePrice,
    comprehensiveInsurancePrice,
    comprehensiveInsuranceYoungPrice,
  ] = [
    'carPrice',
    'trackingMonthlyRate',
    'servicePrice',
    'licencePrice',
    'compulsoryInsurancePrice',
    'comprehensiveInsurancePrice',
    'comprehensiveInsuranceYoungPrice',
  ].map(v => parseFloat(getValues(v)) || 0)
  return useMemo(() => {
    const monthlyPrice =
      (carPrice || 0) +
      (trackingMonthlyRate || 0) +
      (servicePrice || 0) +
      (licencePrice || 0) / 12 +
      (compulsoryInsurancePrice || 0) / 12 +
      (comprehensiveInsurancePrice || 0) / 12 +
      (comprehensiveInsuranceYoungPrice || 0) / 12

    return monthlyPrice.toFixed(2)
  }, [
    carPrice,
    trackingMonthlyRate,
    servicePrice,
    licencePrice,
    compulsoryInsurancePrice,
    comprehensiveInsurancePrice,
    comprehensiveInsuranceYoungPrice,
  ])
}
